/* eslint-disable react-hooks/exhaustive-deps */
import { ArtButton, DAOButton } from "components/button";
import Selection, { getWalletOptions } from "components/input/select-input";
import Config from "config";
import dayjs from "dayjs";
import { CustomerInterface, MstrSharedRevenueTime, MstrTimeDisplay } from "interfaces";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducer/store";
import { bulkSetUserInfo } from "reducer/user.slice";
import { Modal, Radio } from "semantic-ui-react";
import { api, ui, utils } from "services";
import { useInterval } from "services/useInterval";

export default function StakePeriod({ open, onClose, onSuccess, stakeConfig, trigger, setTrigger, unstakeAmount, unstakeFn, withdrawAmount, setWithdraw }: any) {
  const [amount, setAmount] = useState(0);
  const [isListeningMSTR, setIsListeningMSTR] = useState(false);
  const [loading, setLoading] = useState(false);
  // -1 = ingame-wallet
  const [value, setValue] = useState(-1);
  const user = useSelector((state: RootState) => state.user);
  const wallets = useSelector((state: RootState) => state.wallets);
  const [options, setOptions] = useState([]);
  const { t } = useTranslation();
  const [stakeTime, setStakeTime] = useState(MstrSharedRevenueTime.SixMonth)
  const dispatch = useDispatch();

  useEffect(() => {
    setAmount(unstakeAmount || withdrawAmount)
  }, [unstakeAmount, withdrawAmount])

  useEffect(() => {
    if (user?.[CustomerInterface.id]) {
      let data = getWalletOptions(wallets)
      let inGame = {
        icon: "/assets/images/page/dao.svg",
        name: "In-game Balance",
        value: -1
      }
      setOptions([inGame, ...data]);
      data.length > 0 && setValue(-1)
    }
  }, [wallets])

  async function onSubmit() {
    if (!amount) { return }
    setLoading(true);
    if (withdrawAmount) {
      api.restakeMstrTime(stakeTime).then((rs) => {
        let { customerInfo } = rs;
        dispatch(bulkSetUserInfo(customerInfo));
        onSuccess && onSuccess()
        setTrigger(!trigger)
        close();
        ui.alertSuccess("Stake MSTR successful !", "Please wait a minute to update MSTR in your wallet !")
      }).catch((err) => {
        close();
        setLoading(false);
        ui.alertFailed("Transaction failed !", t(err.message));
      })
      return;
    }

    if (value === -1) {
      api.stakeMSTRPeriodIngame(amount, stakeTime).then((rs) => {
        let { customerInfo } = rs;
        dispatch(bulkSetUserInfo(customerInfo));
        onSuccess && onSuccess()
        setTrigger(!trigger)
        close();
        ui.alertSuccess("Stake MSTR successful !", "Please wait a minute to update MSTR in your wallet !")
      }).catch((err) => {
        close();
        setLoading(false);
        ui.alertFailed("Transaction failed !", t(err.message));
      })
    } else {
      api.depositPeriodMSTR(String(amount), stakeTime).then(
        (rs) => {
          onSuccess && onSuccess()
          setIsListeningMSTR(true);
          close();
          ui.alertSuccess("Stake MSTR successful !", "Please wait a minute to update MSTR in your wallet !")
        },
        (err) => {
          close();
          setLoading(false);
          if (err.message === "Already processing eth_requestAccounts. Please wait.") {
            ui.alertFailed("Transaction failed !", "Please connect your metamask extension in browser first !");
          } else {
            ui.alertFailed("Transaction failed !", t(err.message));
          }
        }
      );
    }
  }

  useInterval(async () => {
    if (window.sessionStorage.getItem("token")) {
      let mstrMsg: any = { data: [] };
      mstrMsg = await api.getMessages("user_mstr_stakelist_update")
      const data = [...mstrMsg.data];
      if (data.length > 0) {
        setTrigger(!trigger)
      }
    }
  }, 5000)

  function close() {
    setAmount(0);
    setValue(-1);
    setStakeTime(MstrSharedRevenueTime.SixMonth);
    setLoading(false);
    setWithdraw  && setWithdraw(0);
    onClose();
  }

  useEffect(() => {
    setAmount(0)
  }, [value])

  return (
    <Modal
      size="small"
      open={open}
      style={{ width: "unset" }}
    >
      <div
        className="max-w-[564px] w-screen zoom-90"
      >
        <div className="text-red cursor-pointer absolute float-right right-4 top-3"
          onClick={() => {
            if (!loading) {
              close();
            }
          }}
        >
          <img src="/assets/images/icons/close-popup.png" alt="close" className="" />
        </div>

        <div className="max-w-[564px] w-screen bg-[#2C2B30] pb-8 rounded-2xl">
          <div>
            <div className="text-center text-white text-xl py-6 font-extrabold main-font-bold">
              {unstakeAmount || withdrawAmount ? t("Hot Deal") : t("Stake MSTR")}
            </div>
            <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-4" />

            <div className="w-11/12 mx-auto">
              {unstakeAmount || withdrawAmount ?
                <div className="p-4 bg-[#1F1D24] text-white mt-6 main-font-light rounded-md leading-6 mb-4">
                  You are withdrawing <span className="font-bold text-orange">{utils.displayFloat(unstakeAmount || withdrawAmount || 0, 8, false)} MSTR</span>, do you want to convert this amount of MSTR to term stake to get a higher incentive?
                </div> :
                <div>
                  <div className="text-center flex mx-auto justify-center w-full rounded-lg mb-3">
                    <div className="relative w-full">
                      <div className="flex absolute inset-y-0 left-0 pl-3 pointer-events-none flex-col">
                        <span className="text-gray text-sm mt-1 mr-2">{t("wallet_address")}</span>
                        <div className="flex">
                          <img className="h-6 w-6 mt-1" src={`/assets/images/wallets/metamask.svg`} alt="coin" />
                        </div>
                      </div>
                      <Selection
                        setValue={setValue}
                        options={options}
                        disabled={loading}
                        theme="dark"
                      />
                    </div>
                  </div>

                  <div className="text-center text-white flex mx-auto justify-center w-full overflow-hidden rounded-lg ">
                    <div className="relative w-full">
                      <div className="flex absolute inset-y-0 left-0 pl-3 pointer-events-none flex-col">
                        <span className="text-[#999999] text-sm mt-1">{t("amount")}</span>
                        <img className="h-6 w-6 mt-1" src={`/assets/images/items/mstr-icon.webp`} alt="coin" />
                      </div>
                      <input
                        type="text"
                        className="text-sm font-semibold block w-full h-[54px] pl-11 pt-5 text-[#E4E4E4] border border-r-0 border-input bg-[#1F1D24] rounded-l-md"
                        value={amount}
                        onChange={(e: any) => {
                          let targetValue = e.target.value;
                          if (loading) {
                            return;
                          }
                          if (!/^-?\d*\.?\d*$/.test(targetValue)) {
                            return;
                          }
                          let available = value === -1 ? user?.[CustomerInterface.mstr] : user?.mstr_wallet;
                          available = Math.floor(available * 1e8) / 1e8;
                          targetValue = Number(targetValue) > Number(available) ? available : targetValue;
                          let textValue = utils.toFixed(targetValue).toString();
                          let splitDots = textValue.split(".");
                          if (splitDots.length > 1) {
                            let afterDots = splitDots[1];
                            if (afterDots.length > 8) {
                              return;
                            }
                            if (targetValue < 1e-8 && afterDots.length > 7 && 1e-8 <= available) {
                              setAmount(utils.toFixed(1e-8))
                              return;
                            }
                          }
                          targetValue = targetValue.toString();
                          let isFormat = targetValue.substr(targetValue.length - 1);
                          setAmount(isFormat === '.' ? targetValue : Number(targetValue))
                        }}
                      />
                    </div>
                    <div
                      className="unselectable bg-[#1F1D24] h-[54px] px-4 text-center pt-[19px] font-medium cursor-pointer text-[#E89F01] border border-l-0 border-input rounded-r-md"
                      style={{
                        // borderLeft: "1px solid #7C6F5F",
                      }}
                      color="yellow"
                      onClick={(evt) => {
                        if (loading) {
                          return;
                        }
                        evt.preventDefault();
                        let available = value === -1 ? user?.[CustomerInterface.mstr] : user?.mstr_wallet;
                        available = Math.floor(available * 1e8) / 1e8;
                        setAmount(available);
                      }}
                    >
                      {t("max")}
                    </div>
                  </div>

                  <div className="text-[#999999] mt-3">
                    {t("Balance")}: {" "}
                    <span>
                      <img className="h-6 w-6 mx-1 inline-block" src={`/assets/images/items/mstr-icon.webp`} alt="coin" />
                      {utils.convertToInternationalCurrencySystem(value === -1 ? user?.[CustomerInterface.mstr] : user?.mstr_wallet, 8)} MSTR
                    </span>
                  </div>

                  {amount < 1e-8 && <div className="font-normal text-white-light my-1.5 text-sm text-red">
                    {t("Minimum amount")}: {" "}
                    <span>
                      <img className="h-6 w-6 mx-1 inline-block" src={`/assets/images/items/mstr-icon.webp`} alt="coin" />
                      {utils.toFixed(1e-8)} MSTR
                    </span>
                  </div>}
                </div>}

              <div className="text-white mt-1">Period</div>
              <div className="gap-4 flex flex-col mt-2 mb-5">
                {['6 months', '9 months', '12 months'].map((v, idx) => {
                  return (
                    <div
                      className={`flex justify-between text-white bg-[#1F1D24] hover:bg-[#3E362B] hover:text-[#E89F01]
                        font-bold px-3 cursor-pointer rounded-md ${idx === stakeTime && 'bg-[#3E362B] text-[#E89F01]'}`}
                      onClick={() => {
                        if (loading) {
                          return;
                        }
                        setStakeTime(idx)
                      }}>
                      <div className="flex gap-4 py-3 ">
                        <input type="radio" className="dao-radio" checked={idx === stakeTime} onClick={(e) => {
                          // e.preventDefault();
                          setStakeTime(idx)
                        }}></input>
                        <div>
                          <div>{v}</div>
                          <div className="text-[#999999] text-sm mt-1">End date: {dayjs().add((6 + 3 * idx), 'month').toDate().toLocaleDateString('en-US',
                            // @ts-ignore
                            Config.FormattedDateLong
                          )}</div>
                        </div>
                      </div>
                      <div className="flex gap-4 w-[200px]">
                        <div className="h-[80%] self-center border-[#47433C]" style={{ borderWidth: "0.1px" }}></div>
                        <div className="text-[#999999] py-3 self-center">
                          <div className="text-sm">
                            Current APR
                          </div>
                          <div className="text-white mt-1">
                            {utils.displayFloat(
                              stakeConfig?.mstrTimePool?.[idx ?? 0] * 365 * 100 / (Number(stakeConfig?.customerTotalMstrStakeTime?.[idx] ?? 0)), 8, false
                            ) + " %"}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>

              <div className="p-4 bg-[#1F1D24] text-white mt-6 main-font-light rounded-md">
                <ul className="text-sm">
                  <li className="ml-2">
                    <div className="dot mr-2"></div>
                    <span className="text-white">{t('period_stake_message_1')} </span>
                  </li>
                  <li className="mt-1 ml-2">
                    <div className="dot mr-2"></div>
                    <span className="text-white">{t('period_stake_message_2')}</span>
                  </li>
                  <li className="mt-1 ml-2">
                    <div className="dot mr-2"></div>
                    <span className="text-white">{t('period_stake_message_3')} </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex w-full gap-4 mt-5 text-center items-center mx-auto justify-center">
              {unstakeAmount && <div className="w-[112px]">
                <DAOButton
                  color="white"
                  theme="red"
                  className="py-4"
                  disabled={!amount || Number(amount) <= 0}
                  loading={loading}
                  onClick={async () => {
                    await unstakeFn();
                  }}
                >
                  {t("unstake")}
                </DAOButton>
              </div>}
              <div className="w-[112px]">
                <DAOButton
                  color="white"
                  theme="orange"
                  className="py-4"
                  disabled={!amount || Number(amount) <= 0}
                  loading={loading}
                  onClick={() => {
                    ui.confirmAction("Confirm action",
                      <>
                        <div className="text-left">
                          Are you sure you want to stake <span className="font-bold text-orange">{amount} MSTR</span> with a term of {
                            // @ts-ignore
                            MstrTimeDisplay[MstrSharedRevenueTime[stakeTime]]
                          }.
                        </div>
                        <div className="py-2 text-left">
                          Please type <em className="font-bold">confirm</em> to confirm you action.
                        </div>
                      </>
                      , "default", async () => await onSubmit())
                  }}
                >
                  {t("stake")}
                </DAOButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal >
  );
}
